export default __webpack_public_path__ + "static/media/icon-search-white.28c2bf48.svg";